import React from 'react';
import { ERoutes } from '../types';
import GlobalLayout from '../layouts/GlobalLayout/GlobalLayout';
import AuthRoutes from './AuthRoutes';

import MainAsync from '../components/main/Main.async';
import DeleteAccountPage from '../components/DeleteAccountPage/DeleteAccountPage';
import ChangeEmailPage from '../components/ChangeEmailPage/ChangeEmailPage';

const StartRoutes = {
  path: ERoutes.home,
  element: <GlobalLayout />,
  children: [
    {
      path: ':page?/:id?',
      element: <MainAsync />,
    },
    {
      path: 'account/delete',
      element: <DeleteAccountPage />,
    },
    {
      path: 'account/email',
      element: <ChangeEmailPage />,
    },
    AuthRoutes,
  ],
};

export default StartRoutes;
